//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  layout: 'marketing-page',
  head() {
    return {
      title: 'Electronics Inventory Management Software | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Manage electronic component inventory with ease. Track stock levels, storage locations and part data, and keep everything in sync with your BOMs and procurement — all in one place.'
        }
      ]
    };
  }
};
